import { pharmacyClient } from "@/connect";

export const getSalesPerItem = async (page: number, pageSize: number) => {
  return await pharmacyClient.salesPerItemReport({
    pageNumber: page,
    pageSize: pageSize,
  });
};